import { IAccountDetailsDTO } from './accounts.dao';
import { IRolesDTO } from './roles.dao';
import { ICsvColumn } from './connections.dao';
import { IAccountGroupDTO } from './account-groups.dao';
import { IPaginationParams } from './shared.dto';

abstract class IUsersDAO {
    public abstract getUsers(requestParams: IGetUsersParams): Promise<IUsersListDTO>;
    public abstract createUser(userDetails: IUserCreateDTO): Promise<IUserDetailsDTO>;
    public abstract getUser(username: string): Promise<IUserDetailsDTO>;
    public abstract getCurrentUser(): Promise<IUserDetailsDTO>;
    public abstract editUser(userDetails: IUserUpdateDTO, username: string): Promise<void>;
    public abstract deleteUser(username: string): Promise<void>;
    public abstract getUsersCSV(): Promise<void>;
    public abstract getAccountUsers(params: { accountId: number; activeOnly?: boolean } ): Promise<IUserDetailsDTO[]>;
    public abstract searchDeliveryTeamMembers(requestParams: IGetUsersParams): Promise<IUsersListDTO>;
    public abstract getConnectionExportTemplates(requestParams: IGetUsersParams): Promise<IConnectionExportTemplate[]>;
    public abstract createConnectionExportTemplate(template: IConnectionExportTemplate): Promise<IConnectionExportTemplate>;
    public abstract deleteConnectionExportTemplates(connectionExportTemplateId: number): Promise<void>;
    public abstract activateUser(username: string, active: boolean): Promise<void>;
    public abstract getAccountCoordinators(params: IPaginationParams ): Promise<IUsersListDTO>;

}

enum UserAction {
    Create = 'Create',
    Edit = 'Edit',
    Delete = 'Delete'
}

interface IGetUsersParams {
    query?: string;
    page?: number;
    size?: number;
    accountIds?: string | undefined;
    roleIds?: string | undefined;
    oeStaffOnly?: boolean | undefined;
    activeOnly?: boolean;
}

interface IUsersListDTO {
    users: IUserDetailsDTO[];
    totalElements: number;
}

interface IUserDTO {
    accounts: IAccountDetailsDTO[];
    firstName: string;
    lastName: string;
    email: string;
    isSuperuser: boolean;
    isOpenExchangeStaffMember: boolean;
    isAllAccounts: boolean;
    confirmationEmailPasswordTrigger: boolean;
}

interface IUserDetailsDTO extends IUserDTO {
    roles: IRolesDTO[];
    username: string;
    accountGroups: IAccountGroupDTO[];
    active: boolean;
    isActive?: boolean;
    lockedSystemUser: boolean;
    insertAt?: string;
    lastLoginAt?: string;
}

interface IUserUpdateDTO extends Omit<IUserDTO, 'accounts'> {
    tempPassword?: string;
    addedAccounts: number[];
    removedAccounts: number[];
    addedRoles: string[];
    removedRoles: string[];
    addedAccountGroups: number[];
    removedAccountGroups: number[];
    lockedSystemUser: boolean;
}

interface IUserCreateDTO extends Omit<IUserDTO, 'accounts'> {
    accountIds: number[];
    roleLinkNames: string[];
    tempPassword: string;
    accountGroupIds: number[];
}

interface IUserFormDTO extends Partial<IUserDetailsDTO> {
    title: string;
}

interface IConnectionExportTemplate {
    columns: ICsvColumn[];
    name?: string;
    connectionExportTemplateId?: number;
}

export {
    IUserDTO,
    IUsersDAO,
    UserAction,
    IUsersListDTO,
    IUserUpdateDTO,
    IUserCreateDTO,
    IUserDetailsDTO,
    IUserFormDTO,
    IGetUsersParams,
    IConnectionExportTemplate
};
